import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function Today(_: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.today}>
      <p className={styles.name}>
        {t("projectPage.synthesisPage.monitoring.today")}
      </p>
      <Icon className={styles.icon} />
    </div>
  );
}

export { Today };
